import React, { Component } from 'react'
import { connect } from 'react-redux'

import { fetchAccounts, promoteToAdmin, deleteAccount } from '../../ducks/organisation-admin'
import AccountList from '../AccountList'

class OrganisationAccountListContainer extends Component {
  componentDidMount() {
    this.props.fetchAccounts(this.props.currentOrganisation.organisation.id)
  }

  handlePromoteToAdmin = accountId => {
    this.props.promoteToAdmin(this.props.currentOrganisation.organisation.id, accountId)
  }

  handleDelete = accountId => {
    this.props.deleteAccount(accountId)
  }

  render() {
    const { accounts, currentAccount, deletedAccountIds } = this.props

    return (
      <AccountList
        accounts={accounts}
        onDelete={this.handleDelete}
        deletedAccountIds={deletedAccountIds}
        onPromoteToAdmin={this.handlePromoteToAdmin}
        isSuperAdminView={false}
        currentAccount={currentAccount}
      />
    )
  }
}

export default connect(
  state => ({
    currentAccount: state.account.get('currentAccount'),
    currentOrganisation: state.account.get('currentOrganisation'),
    accounts: state.organisationAdmin.get('accounts'),
    deletedAccountIds: state.organisationAdmin.get('deletedAccountIds')
  }),
  {
    fetchAccounts,
    promoteToAdmin,
    deleteAccount
  }
)(OrganisationAccountListContainer)



// WEBPACK FOOTER //
// ./src/components/smart/OrganisationAccountListContainer.js